import { render, staticRenderFns } from "./comp_CheckoutConfirmCard-payment.vue?vue&type=template&id=72f094f0&"
import script from "./comp_CheckoutConfirmCard-payment.vue?vue&type=script&lang=js&"
export * from "./comp_CheckoutConfirmCard-payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports